module.exports = __webpack_public_path__ + "static/img/us.9059391.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/us.jpeg
// module id = XLoc
// module chunks = 1